import { tv as tvBase, type VariantProps } from "tailwind-variants";

/**
 * Re-export tailwind-variants with AlignUI configuration
 * tv = tailwind-variants for managing component variants
 */
export const tv = tvBase;
export type { VariantProps };
